module.exports = __webpack_public_path__ + "img/globe-americas-solid.f0bbb0d3.svg";